import { IsEnum, IsInt, IsNotEmpty, IsPositive } from 'class-validator';
import { ChallengeActivityTypesEnum } from '../../enums';

export class ChallengesStatsDto {
	@IsEnum(ChallengeActivityTypesEnum)
	@IsNotEmpty()
	activityType: ChallengeActivityTypesEnum;

	@IsInt()
	@IsPositive()
	@IsNotEmpty()
	timeInSeconds: number;

	@IsInt()
	@IsPositive()
	distanceInMeters?: number;

	@IsInt()
	@IsPositive()
	average?: number;
}
